import xhr from "lib/xhr";
import { queryString } from "lib/util";
import { apiUrl } from "./api";

export const fetchSearchItems = async (params = {}) => {
  const query = queryString(params, true);
  return await xhr.get(apiUrl(`advanced_search?${query}`), { transformData: true });
};
